export class WrapUpData {
    interactionTypeVal: any;
    interactionMode: any = 'NA';
    interactionModeSubType: any;
    interactionFeedback: string = '';
    comments: any;
    wrapupTopicList: any = [];
    thirdParty: any;
    primaryTopic: any;
    contactName?: string = '';
    unknownCallerType?: string = '';
    previousUknownCallerType?: string = '';
    unknownCustomerName?: string = '';
    unknownCallerWrapupPage:boolean = false;
    callStatus?:string='';
    // CCR1-12455 wrap-up fields for call disposition
    howInteractionEnded: string = '';  // dropdown
    whereOtherText: string = '';
    whereSingleSelect: string = '';   // for transfer
    whereMultiSelect: string[] = []; // for referral
    where: string = '';       // consolidated where field for IH payload
}